import React from "react";

const raleway = { fontFamily: "'Geist', sans-serif" };
const geistMono = { fontFamily: "'Geist Mono', monospace" };
const instrumentSerif = { fontFamily: "'Instrument Serif', Georgia, serif" };

const REQUIREMENTS = [
  {
    label: "Account Requirement",
    desc: "You need an active Zikora MFB account that matches the loan type you're applying for.",
  },
  {
    label: "Required Documents",
    desc: "Valid ID, BVN, recent account activity, and any supporting documents requested for review.",
  },
  {
    label: "Minimum Tenure",
    desc: "Applicants may need to maintain an active account relationship for a minimum period before eligibility.",
  },
];

const LoanEligibility = () => (
  <>
    <style>{`
			@media (max-width: 767px) {
				.lelig-inner { flex-direction: column !important; gap: 24px !important; }
				.lelig-left  { max-width: 100% !important; flex: 0 0 auto !important; }
				.lelig-right { flex: 0 0 auto !important; }
				.lelig-row   { flex-direction: column !important; gap: 8px !important; }
				.lelig-label { width: auto !important; }
			}
		`}</style>

    <section
      style={{
        width: "100%",
        background: "transparent",
        boxSizing: "border-box",
        padding: "clamp(48px, 6.94vw, 100px) clamp(20px, 5.56vw, 80px)",
      }}
    >
      <div
        className="lelig-inner"
        style={{
          maxWidth: "1280px",
          margin: "0 auto",
          display: "flex",
          alignItems: "flex-start",
          gap: "clamp(32px, 6.94vw, 100px)",
        }}
      >
        {/* Left */}
        <div
          className="lelig-left"
          style={{
            flex: "1 1 280px",
            maxWidth: "520px",
            display: "flex",
            flexDirection: "column",
            gap: "clamp(16px, 1.67vw, 24px)",
          }}
        >
          {/* Label */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <span
              style={{
                width: "8px",
                height: "8px",
                borderRadius: "50%",
                backgroundColor: "#295B4A",
                flexShrink: 0,
                display: "inline-block",
              }}
            />
            <span
              style={{
                ...geistMono,
                fontWeight: 500,
                fontSize: "12px",
                lineHeight: "1",
                letterSpacing: "0.1em",
                color: "#295B4A",
                textTransform: "uppercase",
              }}
            >
              Eligibility
            </span>
          </div>

          <h2
            style={{
              ...instrumentSerif,
              fontWeight: 400,
              fontSize: "clamp(28px, 4.17vw, 60px)",
              lineHeight: 1.1,
              letterSpacing: "-0.01em",
              color: "#132A22",
              margin: 0,
            }}
          >
            Check if you're eligible to apply
          </h2>
          <p
            style={{
              ...raleway,
              fontWeight: 400,
              fontSize: "clamp(14px, 1.25vw, 18px)",
              lineHeight: 1.6,
              color: "#3F5445",
              margin: 0,
            }}
          >
            Simple requirements to help you prepare before starting your
            application.
          </p>
        </div>

        {/* Right */}
        <div className="lelig-right" style={{ flex: "2 1 320px", minWidth: 0 }}>
          {REQUIREMENTS.map((item, i) => (
            <div
              key={item.label}
              className="lelig-row"
              style={{
                display: "flex",
                gap: "clamp(24px, 3.33vw, 48px)",
                paddingTop: i === 0 ? 0 : "clamp(24px, 2.78vw, 40px)",
                paddingBottom: "clamp(24px, 2.78vw, 40px)",
                borderTop: i === 0 ? "none" : "1px solid #D1E8DC",
                alignItems: "flex-start",
              }}
            >
              <p
                className="lelig-label"
                style={{
                  ...raleway,
                  fontWeight: 700,
                  fontSize: "clamp(14px, 1.11vw, 16px)",
                  lineHeight: 1.4,
                  color: "#132A22",
                  margin: 0,
                  flexShrink: 0,
                  width: "clamp(130px, 12vw, 180px)",
                }}
              >
                {item.label}
              </p>
              <p
                style={{
                  ...raleway,
                  fontWeight: 400,
                  fontSize: "clamp(14px, 1.11vw, 16px)",
                  lineHeight: 1.7,
                  color: "#3F5445",
                  margin: 0,
                }}
              >
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  </>
);

export default LoanEligibility;
